const KEY = "ff_view_tenant";

export const getViewTenant = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY)); } catch { return null; }
};
export const setViewTenant = (t) => sessionStorage.setItem(KEY, JSON.stringify({ id: t.id, name: t.name }));
export const clearViewTenant = () => sessionStorage.removeItem(KEY);
export const viewHeaders = () => { const v = getViewTenant(); return v ? { "X-View-Tenant": v.id } : {}; };
